import { useEffect, useRef } from "react";

const VIDEO_SRC =
  "https://customer-assets.emergentagent.com/job_blend-luxe-2/artifacts/qd2zt3i2_Firefly%20Create%20a%20premium%203D%20product%20advertisement%20video%20using%20the%20attached%20reference%20image%20of%20the%20Sm.mp4";
const POSTER_FALLBACK =
  "https://customer-assets.emergentagent.com/job_7837e2b0-0c58-44b6-ba36-d34f0cc5b7e9/artifacts/s0t3veiu_Final%20Design%20-%20spice%20bottles.png";

const HeroVideo = () => {
  const ref = useRef(null);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    const tryPlay = () => {
      const p = v.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
    };
    tryPlay();
    v.addEventListener("loadedmetadata", tryPlay);
    v.addEventListener("canplay", tryPlay);
    return () => {
      v.removeEventListener("loadedmetadata", tryPlay);
      v.removeEventListener("canplay", tryPlay);
    };
  }, []);

  return (
    <div
      data-testid="hero-video"
      className="relative w-full h-full min-h-[560px] flex items-center justify-center"
    >
      {/* Ambient glow */}
      <div className="absolute -inset-8 bg-gradient-to-br from-[#D4AF37]/25 via-[#D4AF37]/5 to-transparent rounded-full blur-[100px] pointer-events-none" />
      <div className="absolute inset-10 bg-[#8A2323]/15 rounded-full blur-[140px] pointer-events-none" />

      {/* Video with radial mask so edges feather into the page */}
      <div
        className="relative w-full h-full"
        style={{
          WebkitMaskImage:
            "radial-gradient(ellipse 88% 82% at center, #000 60%, rgba(0,0,0,0.85) 78%, rgba(0,0,0,0) 100%)",
          maskImage:
            "radial-gradient(ellipse 88% 82% at center, #000 60%, rgba(0,0,0,0.85) 78%, rgba(0,0,0,0) 100%)",
        }}
      >
        <video
          ref={ref}
          src={VIDEO_SRC}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          disablePictureInPicture
          controlsList="nodownload noplaybackrate nofullscreen"
          className="w-full h-full object-cover bg-[#0A0A0A]"
          aria-label="Smart Premium Spices product showcase"
        />
      </div>

      {/* Edge fades to blend into the dark page */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/4 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/50 to-transparent" />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-1/5 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-[#0A0A0A] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-[#0A0A0A] to-transparent" />
    </div>
  );
};

export default HeroVideo;
